import { Form } from 'react-bootstrap'
import styled from 'styled-components'
import { t } from 'i18next'
import { colors } from '../../../styles/colors'
import InformationPopover from '../../InformationPopover/InformationPopover'
import MediaQuery from 'react-responsive'

const StyledRFID = styled.div`
  color: ${colors.gray3};
  font-weight: 600;
`
const RFIDView = ({id, rfid, disabled = false, handleOnChange, handleOnBlur, handleOnKeyDown, formError}) => {

  return (
    <div className="mb-3">  
      <Form.Group className="mb-3">
      <Form.Label >{t('inventory:scanCode')}</Form.Label><MediaQuery minWidth={550}><InformationPopover header={t('inventory:scanCode')} content={t('returnsProcessingPage:scanCodeInfo')} /></MediaQuery>
        {!disabled
          ?
          <>
          <Form.Control
            id={id}
            name="rfid"
            placeholder={t('inventory:scanCode')}
            value={rfid}
            onChange={handleOnChange}
            onBlur={handleOnBlur}
            onKeyDown={handleOnKeyDown}
            isInvalid={!!formError}
          />
          <Form.Control.Feedback type="invalid">
          {formError}
          </Form.Control.Feedback>
          </> 
          : <StyledRFID>{`${t('inventory:scanCode')}: ${rfid}`}</StyledRFID>
        }
      </Form.Group>
    </div>

  )
}
export default RFIDView